<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row>
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="getExpandClasses(u)" v-for="(u, uindex) in preset[0].lane" v-bind:key="`lcrbll`+uindex">
					<div class="collapsible-heading">
						<div class="d-flex">
							<div class="collapsible-heading__image" @click="onToggleExpand(uindex)">
								<b-img :src="LaneClosureRequest.getLaneImage100(u.laneId.value)"></b-img>
							</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand(uindex)">{{LaneClosureRequest.getLaneText(u.laneId.value)}} <small v-bind:key="'lcrbllcount'+renderCounter" v-html="getTitleText(uindex)"></small><br/><small v-html="getPeakReasonText(uindex)"></small><br/></div>
							<div class="collapsible-heading__review-blocks" @click="onToggleExpand(uindex)"><div class="flex-table"><div class="flex-table-cell">Review Blocks</div></div></div>
							<div class="collapsible-heading__toggle">
								<div class="flex-table">
								<b-button href="#" variant="collapsible" :class="isExpanded(u) ? ' flex-table-cell' : ' collapsed flex-table-cell'" :aria-expanded="isExpanded(u) ? 'true' : 'false'" aria-controls="collapseLaneListing" @click="onToggleExpand(uindex)">
									<span class="when-opened">
										<font-awesome-icon icon="chevron-down" />
									</span>
									<span class="when-closed">
										<font-awesome-icon icon="chevron-right" />
									</span>
								</b-button>
								</div>
							</div>
							<button type="button" class="collapsible-heading__remove" title="Remove Lane" @click="onRemoveAll(uindex)"><font-awesome-icon icon="trash" /></button>
						</div>
					</div>
					<b-collapse :id="'collapseLaneListing'+uindex" :visible="isExpanded(u)" class="collapsible-entries">
						<div class="collapsible-entries__wrapper">
						<div class="is-entry">
								<div class="d-flex collapsible-entry">
									<div class="collapsible-entry__icon"><b-img :src="LaneClosureRequest.getLaneImage(u.laneId.value)"></b-img></div>
									<div class="collapsible-entry__set-all-blocks flex-grow-1">SET AFFECTED BLOCKS</div>
									<div class="collapsible-entry__all-yes-button"><b-button variant="primary" type="button" @click="setAllYes(uindex)">Closing Lane for All Blocks</b-button></div>
									<div class="collapsible-entry__all-no-button"><b-button variant="secondary" type="button" @click="setAllNo(uindex)">All Blocks Open</b-button></div>
								</div>
						</div>
							<div :class="classes(b2index,uindex)" v-for=" (b, b2index) in value" v-if="canBeAdded(b2index, uindex)" :key="'ebll2index'+b2index+'-'+uindex+'-'+renderCounter">
								<div class="d-flex collapsible-entry">
									<div class="collapsible-entry__icon"><b-img :src="LaneClosureRequest.getLaneImage(u.laneId.value)"></b-img></div>
									<div class="collapsible-entry__title flex-grow-1">
										<a href="#" @click="showOnMap(b.blockId, u)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <strong>{{b.fromStreet.value}}</strong> and <strong>{{b.toStreet.value}}</strong></a></div>
									<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId, u)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
									<div class="collapsible-entry__switch">
										<div class="closing-open-switch-field">
												<input :id="switchId('ebllane',uindex,b2index,u.laneId.value)"  class="closing-open-switch" :checked="isEntry(b2index, uindex)" type="checkbox" @change="toggleRemoveBlock(b2index,uindex,switchId('ebllane',uindex,b2index,u.laneId.value))" >
												<label :for="switchId('ebllane',uindex,b2index,u.laneId.value)"></label>
										</div>
									</div>
									<div class="collapsible-entry__delete-block-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="onRemoveBlock(b.blockId)"><span class="icon-trash"></span></b-button></div>
								</div>
							</div>


							<div class="is-not-entry">
									<div class="d-flex collapsible-entry">
										<div class="collapsible-entry__icon"><b-img :src="LaneClosureRequest.getLaneImage(u.laneId.value)"></b-img></div>
										<div class="collapsible-entry__set-all-blocks flex-grow-1">Need to add or remove a street block from this request? Open the  map <b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button> and click on the street or block.</div>
									<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
									</div>
							</div>

						</div>
					</b-collapse>
				</div>
					<!-- End of desktop -->

				<div v-if="$store.state.isMobile" :class="isExpanded(u) ? 'collapsible expanded collapsible__lane' : 'collapsible collapsible__lane collapsed'" v-for="(u, uindex) in preset[0].lane" v-bind:key="`lcrbll`+uindex+'-'+renderCounter">
					<div class="collapsible-heading">
						<div class="d-flex">
							<div class="collapsible-heading__image" @click="onToggleExpandSingle(uindex)">
								<b-img :src="LaneClosureRequest.getLaneImage100(u.laneId.value)"></b-img>
							</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpandSingle(uindex)">{{LaneClosureRequest.getLaneText(u.laneId.value)}}<div class="collapsible-heading__subtitle" v-html="getPeakReasonTextMobile(uindex)"></div><div class="collapsible-heading__subtitle" v-html="getTitleText(uindex)"></div></div>
							<div class="collapsible-heading__toggle">
								<div class="flex-table">
								<b-button href="#" variant="collapsible" :class="isExpanded(u) ? ' flex-table-cell' : ' collapsed flex-table-cell'" :aria-expanded="isExpanded(u) ? 'true' : 'false'" aria-controls="collapseLaneListing" @click="onToggleExpandSingle(uindex)">
									<span>
										<font-awesome-icon icon="chevron-right" />
									</span>
								</b-button>
								</div>
							</div>
							<button type="button" class="collapsible-heading__remove" title="Remove Lane" @click="onRemoveAll(uindex)"><font-awesome-icon icon="trash" /></button>
						</div>
					</div>
				</div>
					<div v-if="$store.state.isMobile">
						<transition name="slide-fade" tag="div" >
							<div class="d-block section-slide-panel" v-if="showPanel">
								<div class="top-controls">
									<button type="button" @click="onSwipeRight">
										<b-img src="/img/nav/icon-back.svg" alt="menu" /> Back
									</button>
								</div>
								<div class="panels-body panels-body-padded panels-no-menu edit-lcr-panels-body">
								<div class="panels-nav-title" v-html="getNavTitle"></div>
								<div v-if="isExpanded(u)" v-for="(u, uindex) in preset[0].lane" v-bind:key="`lcrbllslide`+uindex">
									<div class="panels-body-title">
										<b-img :src="LaneClosureRequest.getLaneImage100(u.laneId.value)"></b-img>
										<div class="flex-grow-1" @click="onToggleExpandSingle(uindex)">{{LaneClosureRequest.getLaneText(u.laneId.value)}}</div>
									</div>
									<div class="panels-body-content"  v-keep-scroll-position>
										<div class="panels-body-content__peak-reason" v-html="getPeakReasonText(uindex)"></div>

									<div :class="classes(b2index,uindex)" v-for=" (b, b2index) in value" v-if="canBeAdded(b2index, uindex)" :key="'ebll2index'+b2index+'-'+uindex+'-'+renderCounter">
										<div class="d-flex collapsible-entry">
											<div class="collapsible-entry__switch">
												<div class="closing-open-switch-field">
														<input :id="switchId('ebllane2mobile',uindex,b2index,u.laneId.value)"  class="closing-open-switch" :checked="isEntry(b2index, uindex)" type="checkbox" @change="toggleRemoveBlock(b2index,uindex,switchId('ebllane2mobile',uindex,b2index,u.laneId.value))" >
														<label :for="switchId('ebllane2mobile',uindex,b2index,u.laneId.value)"></label>
												</div>
											</div>
											<div class="collapsible-entry__title flex-grow-1"><a href="#" @click="showOnMap(b.blockId, u)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <strong>{{b.fromStreet.value}}</strong> and <strong>{{b.toStreet.value}}</strong></a></div>
											<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId, u)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
											<div class="collapsible-entry__delete-block-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="onRemoveBlock(b.blockId)"><span class="icon-trash"></span></b-button></div>
										</div>
									</div>
									<div class="is-not-entry">
											<div class="d-flex collapsible-entry">
												<div class="collapsible-entry__set-all-blocks flex-grow-1">Need to add or remove a street block from this request? Open the  map <b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button> and click on the street or block.</div>
											<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
											</div>
									</div>
									</div>
								</div>
								<div class="panels-apply">
									<div class="d-flex">
										<div class="panels-apply__close"><b-button @click="setAllYes(null)" variant="light" class="close-button" type="button"><img src="/img/assets/set-all-close.svg" alt="" />Closing</b-button></div>
										<div class="panels-apply__open"><b-button @click="setAllNo(null)" variant="light" class="open-button" type="button"><img src="/img/assets/set-all-open.svg" alt="" />Open</b-button></div>
										<div class="panels-apply__save"><b-button @click="onApplySingle()" variant="secondary" class="save-button" type="button"><span class="btn__icon"><img src="/img/assets/icon-checkmark-blue.svg"/></span><span class="btn__text">Apply</span></b-button></div>
									</div>
								</div>
							</div>
							</div>
						</transition>
					</div>

				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'
import Vue from 'vue'

export default {
	name: 'LaneClosureRequestBlockLaneListing',
	props: ['value', 'preset', 'expand', 'scrollTop', 'renderCounter'],
	data() {
		return {
			isEditing: false,
			editingIndex: null,
			LaneClosureRequest: LaneClosureRequest,
			backupBlock: null,
			errorMsg: null,
			lastIndex: null,
			backup: {},
			showPanel: false,
			hasBlocks: true,
		}
	},
	mounted() {
		this.showPanel = this.expand;
		Vue.prototype.$bus.$on('swipe:right:panel', this.onSwipeRight);
	},
	destroyed() {
		Vue.prototype.$bus.$off('swipe:right:panel', this.onSwipeRight);
	},
   watch: {
	'$store.state.isMobile' : function() {
		this.showPanel = false;
	},

   },
	computed: {
		getNavTitle() {
			return "Select Blocks to Close";
		},
		getModalTitle() {
			return 	LaneClosureRequest.getLaneTextMultiLine(this.laneId);
		},
	},
	methods: {

		getExpandClasses(obj) {
			if (obj) {
				if (obj.expand) {
					return "collapsible expanded collapsible__lane";
				}
			}
			return "collapsible collapsible__lane collapsed";
		},
		isExpanded(u) {
			if (u) {
				if (typeof u.expand != "undefined") {
					return u.expand;
				}
			}
			return false;
		},
		classes: function(index,uindex) {
			if (this.isEntry(index,uindex)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},
		getTitleText(uindex) {
			let title = "";
			let qty = 0;
			let total = 0;
			let found = false;
			if (this.value) {
				for (var xx = 0; xx < this.value.length; xx++) {
					found = false;
					for (var x = 0; x < this.value[xx].lane.length; x++) {
						if (
							this.value[xx].lane[x].laneId.value == this.preset[0].lane[uindex].laneId.value
							&& this.value[xx].lane[x].peakId.value == this.preset[0].lane[uindex].peakId.value
						)
						{
							found = true;
						}
					}
					if (LaneClosureRequest.hasTrafficLaneInDirection(this.preset[0].lane[uindex].laneId.value,  this.value[xx].directionId)) {
						total++;
					}
					if (found) {
						qty++;
					}
				}
			}
			let blockText = "blocks";
			if (this.value.length == 1) {
				blockText = "block";
			}
			if (qty > total) {
				qty = total;
			}
			if (qty == 1) {
				title = qty + " of " + total + " " + blockText;
			} else {
				if (qty == 0) {
					title = "<span class='no-blocks-assigned'>assign blocks for closing</span>";
				} else {
					title = qty + " of " + total + " " + blockText;
				}
			}
			if (qty == total) {
				title = "all blocks";
			}
			if (this.$store.state.isMobile || qty == 0) {
				return title;
			} else {
				return " ("+title+")";
			}

		},


		getPeakReasonText(index) {
			let html = "";
			if (this.value) {
				if (this.preset[0].lane[index]) {
					html = LaneClosureRequest.getLanePeakReasonText(this.preset[0].lane[index].peakId.value);
					if (this.preset[0].lane[index].peakId.value == 6 || this.preset[0].lane[index].peakId.value == 13 || this.preset[0].lane[index].peakId.value == 19) {
						html += "<br/>"+this.preset[0].lane[index].peakReason.value;
					}
				}
			}
			return html;
		},
		getPeakReasonTextMobile(index) {
			let html = "";
			if (this.value) {
				if (this.preset[0].lane[index]) {
					let reusltText = "";
					const peakShortTexts = LaneClosureRequest.getClosurePeakReasonShort;
					peakShortTexts.forEach(x => {
						if (x.ids.includes(this.preset[0].lane[index].peakId.value)) {
							reusltText = x.text;
						}
					});

					html += reusltText;
				}
			}

			return html;
		},

		isEntry: function(index, uniqueIndex) {
			if (this.value) {
				if (this.value[index]) {
					for (var x = 0; x < this.value[index].lane.length; x++) {
						if (this.preset[0].lane[uniqueIndex]) {
							if (
							// this.value[index].lanesClosedSameTime.value == this.preset[0].lane[uniqueIndex].lanesClosedSameTime
							// && this.value[index].trafficSignalsAltered.value == this.preset[0].lane[uniqueIndex].trafficSignalsAltered
							this.value[index].lane[x].laneId.value == this.preset[0].lane[uniqueIndex].laneId.value
							&& this.value[index].lane[x].peakId.value == this.preset[0].lane[uniqueIndex].peakId.value
							// && this.value[index].lane[x].peakReason.value == this.preset[0].lane[uniqueIndex].peakReason.value
							) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},

		canBeAdded: function(index, uniqueIndex) {
			if (this.value) {
				if (this.value[index]) {
					for (var x = 0; x < this.value[index].lane.length; x++) {
						if (this.preset[0].lane[uniqueIndex]) {
							if (
							this.value[index].lane[x].laneId.value == this.preset[0].lane[uniqueIndex].laneId.value
							&& this.value[index].lane[x].peakId.value == this.preset[0].lane[uniqueIndex].peakId.value
							) {
								return true;
							}
						}
					}
				}
			}
			if (LaneClosureRequest.hasTrafficLaneInDirection(this.preset[0].lane[uniqueIndex].laneId.value,  this.value[index].directionId)) {
				return true;
			}

			return false;
		},
		switchId(prefix,uindex,block,id) {
			return prefix+"-"+uindex+"-"+block+"-"+id;
		},
		editBlock: function(id) {
			Vue.prototype.$bus.$emit("block:edit-lanes",id);
		},
		showOnMap: function(id, laneField) {
			Vue.prototype.$bus.$emit("block:show-on-map",{id, type: "lane", laneId: laneField.laneId.value});
		},
		showMap: function() {
			Vue.prototype.$bus.$emit("map:toggle", null);
			this.$store.dispatch("map/zoomAllBlocks", null);
		},

		toggleRemoveBlock: function(index, uindex, obj) {
			// this.scrollTop = document.getElementById(obj).parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.scrollTop;
			if (this.isEntry(index, uindex)) {
				Vue.prototype.$bus.$emit("block:list-remove-lane",{laneId:this.preset[0].lane[uindex].laneId.value, blockId:[this.value[index].blockId], peakId:this.preset[0].lane[uindex].peakId.value, peakReason:this.preset[0].lane[uindex].peakReason.value});
			} else {
				Vue.prototype.$bus.$emit("block:list-add-lane",{laneId:this.preset[0].lane[uindex].laneId.value, blockId:[this.value[index].blockId], peakId:this.preset[0].lane[uindex].peakId.value, peakReason:this.preset[0].lane[uindex].peakReason.value});
			}
		},
		setAllYes: function(uindex) {
			var blocks = [];
			var x = 0;
			if (uindex == null) {
				uindex = 0;
				for (uindex = 0; uindex < this.preset[0].lane.length; uindex++) {
					if (this.isExpanded(this.preset[0].lane[uindex])) {
						blocks = [];
						for (x = 0; x < this.value.length; x++) {
							if (this.canBeAdded(x, uindex)) {
								blocks.push(this.value[x].blockId);
							}
						}
						Vue.prototype.$bus.$emit("block:list-add-lane",{laneId:this.preset[0].lane[uindex].laneId.value, blockId:blocks, peakId:this.preset[0].lane[uindex].peakId.value, peakReason:this.preset[0].lane[uindex].peakReason.value});
					}
				}
			} else {
				if (this.isExpanded(this.preset[0].lane[uindex])) {
					blocks = [];
					for (x = 0; x < this.value.length; x++) {
						if (this.canBeAdded(x, uindex)) {
							blocks.push(this.value[x].blockId);
						}
					}
					Vue.prototype.$bus.$emit("block:list-add-lane",{laneId:this.preset[0].lane[uindex].laneId.value, blockId:blocks, peakId:this.preset[0].lane[uindex].peakId.value, peakReason:this.preset[0].lane[uindex].peakReason.value});
				}
			}
		},
		setAllNo: function(uindex) {
			var blocks = [];
			var x = 0;

			if (uindex == null) {
				uindex = 0;
				for (uindex = 0; uindex < this.preset[0].lane.length; uindex++) {
					if (this.isExpanded(this.preset[0].lane[uindex])) {
						for (x = 0; x < this.value.length; x++) {
							if (this.canBeAdded(x, uindex)) {
								blocks.push(this.value[x].blockId);
							}
						}
						Vue.prototype.$bus.$emit("block:list-remove-lane",{laneId:this.preset[0].lane[uindex].laneId.value, blockId:blocks, peakId:this.preset[0].lane[uindex].peakId.value, peakReason:this.preset[0].lane[uindex].peakReason.value});
					}
				}
			} else {
				if (this.isExpanded(this.preset[0].lane[uindex])) {
					blocks = [];
					for ( x = 0; x < this.value.length; x++) {
						if (this.canBeAdded(x, uindex)) {
							blocks.push(this.value[x].blockId);
						}
					}
					Vue.prototype.$bus.$emit("block:list-remove-lane",{laneId:this.preset[0].lane[uindex].laneId.value, blockId:blocks, peakId:this.preset[0].lane[uindex].peakId.value, peakReason:this.preset[0].lane[uindex].peakReason.value});
				}
			}

		},


		onRemoveBlock(blockID) {
			Vue.prototype.$bus.$emit("map:block-remove", blockID);
		},

		onRemoveAll(uindex) {
			Vue.prototype.$bus.$emit("preset-block:remove-lane",{index:uindex});
		},
		onApply: function(uindex) {
			this.showPanel = false;
			let that = this;
			if (this.preset[0].lane[uindex]) {
				setTimeout(() => {
					Vue.prototype.$bus.$emit("preset-block:expand-lane",{index:uindex,expand:!that.preset[0].lane[uindex].expand});
				}, 250);
			}
		},

		onToggleExpand(uindex) {
			// console.log(this.preset[0].lane[uindex].expand);
			this.showPanel = !this.showPanel;
			Vue.prototype.$bus.$emit("preset-block:expand-lane",{index:uindex,expand:!this.preset[0].lane[uindex].expand});
		},

		onToggleExpandSingle(uindex) {
			// console.log(this.preset[0].lane[uindex].expand);
			this.showPanel = !this.showPanel;
			Vue.prototype.$bus.$emit("preset-block:expand-single-lane",{index:uindex,expand:!this.preset[0].lane[uindex].expand});
		},

		onApplySingle: function(uindex) {
			this.showPanel = false;
			setTimeout(() => {
				Vue.prototype.$bus.$emit("preset-block:collapse-lanes");
			}, 250);
		},
		onSwipeRight() {
			this.showPanel = false;
			setTimeout(() => {
				Vue.prototype.$bus.$emit("preset-block:collapse-lanes");
			}, 250);
		},

	}
}
</script>
